import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Joi from "joi-browser";
import http from "../../services/HttpService";
import config from "../../config.json";
import Form from "../../comman/form";
import auth from "../../services/authService";

class AddFormLibrary extends Form {
  constructor(props) {
    super(props);
    this.state = {
      forms: [],
      data: {},
      errors: {},
      submitting: false,
      documentTypes: [
        {
          id: 1,
          name: "ACH Information",
        },
        {
          id: 2,
          name: "Insurance Information",
        },
        {
          id: 3,
          name: "Purchase Order",
        },
      ],
      cannedMessages: [],
    };
  }

  schema = {
    formId: Joi.string().required().label("Form"),
    formType: Joi.string().required().label("Form Type"),
    remarks: Joi.string().allow("").optional().label("Remarks"),
  };

  async componentDidMount() {
    const { data: forms } = await http.get(
      config.GetFormsByType + "Library Form"
    );
    // const newForms = forms.filter(
    //   (x) => x.formName !== "AchInfo" && x.formName !== "InsuranceDetails"
    // );
    const { data: cannedMessages } = await http.get(
      config.GetCodemanager + "Canned Message"
    );
    const { data: documentTypes } = await http.get(
      config.GetCodemanager + "Document Type 2"
    );
    const lastId = documentTypes && documentTypes.length > 0 ? documentTypes[documentTypes.length - 1].id : 0;
    const lastCode = documentTypes && documentTypes.length > 0 ? documentTypes[documentTypes.length - 1].code : 0;
    documentTypes.push({
      id: lastId + 1,
      type: "Document Type 2",
      code: lastCode + 1,
      name: "Insurance Information",
    });
    documentTypes.push({
      id: lastId + 2,
      type: "Document Type 2",
      code: lastCode + 2,
      name: "ACH Information",
    });
    //console.log(documentTypes);
    this.setState({ forms, cannedMessages, documentTypes });
  }

  doSubmit = async () => {
    this.setState({ submitting: true });
    try {
      const user = auth.getCurrentUser();
      const { workflowTask } = this.props;
      const wfTask = { ...workflowTask };
      const { data, forms } = this.state;
      const selectedForm = forms.filter((x) => x.id === parseInt(data["formId"]));
      //console.log(workflowTask);
      //data["formType"] = "Insurance Information";
      //data["formType"] = "ACH Information";
      wfTask.performerId = user.id;
      const frmData = new FormData();
      frmData.append("workflowTask", JSON.stringify(wfTask));
      frmData.append("formId", data["formId"]);
      frmData.append("formName", selectedForm[0].formTitle);
      frmData.append("remarks", data["remarks"]);
      frmData.append("id", data["id"]);
      frmData.append("formType", data["formType"]);
      const { data: result } = await http.post(config.AddFormLibrary, frmData);
      this.props.handleAddFormLibrary(true);
    } finally {
      this.setState({ submitting: false });
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const { selectedForm, workflowTask } = nextProps;
    //console.log(workflowTask);
    const { data } = this.state;
    if (selectedForm && selectedForm !== "") {
      data["formId"] = selectedForm.formId;
      data["remarks"] = selectedForm.remarks;
      data["id"] = selectedForm.id;
      data["formType"] = selectedForm.formType;
      this.setState({ data });
    }
    else {
      data["remarks"] = "";
      data["formType"] = "";
      data["formId"] = "";
      data["id"] = "";
      this.setState({ data })
    }
  };

  handleCannedMessage = ({ currentTarget }) => {
    const { data } = this.state;
    data["remarks"] = currentTarget.value;
    this.setState({ data });
  };

  render() {
    const { forms, documentTypes, cannedMessages, data } = this.state;
    const { showHide, handleModalShowHide } = this.props;
    return (
      <div className="rt-add-form-container">
        <style>{`
          .rt-add-form-container {
            max-width: 100% !important;
            margin: 0 0 12px 0 !important;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 14px;
            padding: 20px 24px;
            box-shadow: 0 10px 15px -3px rgba(0,0,0,0.03), 0 4px 6px -2px rgba(0,0,0,0.03);
          }
          .rt-add-form-header {
            margin-bottom: 16px;
            border-bottom: 1px solid #f1f5f9;
            padding-bottom: 12px;
          }
          .rt-add-form-header h2 {
            font-size: 16px !important;
            font-weight: 700 !important;
            color: #0f172a !important;
            margin: 0 0 4px 0 !important;
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .rt-add-form-header p {
            font-size: 12.5px !important;
            color: #64748b !important;
            margin: 0 !important;
            line-height: 1.4;
          }
          .rt-add-form-container .form-control {
            border: 1.5px solid #cbd5e1 !important;
            border-radius: 9px !important;
            font-size: 13.5px !important;
            padding: 10px 14px !important;
            height: auto !important;
            color: #1e293b !important;
            background-color: #ffffff !important;
            box-shadow: 0 1px 2px 0 rgba(0,0,0,0.02) !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .rt-add-form-container .form-control:focus {
            border-color: #2563eb !important;
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
            background-color: #fafbff !important;
          }
          .rt-add-form-container .wf-input-wrap .form-control {
            padding: 10px 14px 10px 38px !important;
          }
          .rt-add-form-container .form-control-label,
          .rt-add-form-container label {
            font-size: 12.5px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            margin-bottom: 6px !important;
            text-transform: none !important;
            letter-spacing: normal !important;
          }
          .rt-add-form-container .form-group {
            margin-bottom: 24px !important;
          }
          .rt-add-form-container .wf-input-wrap:has(textarea) .wf-input-icon {
            top: 14px !important;
            transform: none !important;
          }
          .rt-add-form-container .form-group.required .form-control-label::after,
          .rt-add-form-container .form-group.required label::after {
            content: " *" !important;
            color: #ef4444 !important;
            font-weight: bold !important;
          }
          .rt-add-form-container textarea.form-control {
            min-height: 100px !important;
            resize: vertical !important;
          }
          .rt-add-form-container .btn-save-form {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            background: #2563eb !important;
            color: #ffffff !important;
            border: 1px solid #2563eb !important;
            padding: 10px 24px !important;
            border-radius: 9px !important;
            font-size: 13.5px !important;
            font-weight: 600 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.15) !important;
          }
          .rt-add-form-container .btn-save-form:hover {
            background: #1d4ed8 !important;
            border-color: #1d4ed8 !important;
            transform: translateY(-1.5px) !important;
            box-shadow: 0 6px 12px -1px rgba(37, 99, 235, 0.25) !important;
          }
          .rt-add-form-container .btn-save-form:active {
            transform: translateY(0) !important;
          }
          .rt-add-form-container .btn-cancel-form {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            background: #ffffff !important;
            color: #475569 !important;
            border: 1.5px solid #cbd5e1 !important;
            padding: 10px 24px !important;
            border-radius: 9px !important;
            font-size: 13.5px !important;
            font-weight: 600 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
          }
          .rt-add-form-container .btn-cancel-form:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1.5px) !important;
          }
          .rt-add-form-container .btn-cancel-form:active {
            transform: translateY(0) !important;
          }
          .rt-add-form-container .btn-save-form:disabled,
          .rt-add-form-container .btn-cancel-form:disabled {
            opacity: 0.65 !important;
            cursor: not-allowed !important;
            pointer-events: none !important;
            transform: none !important;
            box-shadow: none !important;
          }
          .rt-add-form-container .text-danger,
          .rt-add-form-container .alert-danger {
            font-size: 11.5px !important;
            color: #ef4444 !important;
            margin-top: 5px !important;
            font-weight: 500 !important;
            background: none !important;
            border: none !important;
            padding: 0 !important;
            display: block !important;
          }
        `}</style>
        <div className="rt-add-form-header">
          <h2>
            <i className={`fa ${data["id"] ? "fa-pencil-square-o" : "fa-paper-plane"}`} aria-hidden="true" style={{ color: "#2563eb" }}></i>
            {data["id"] ? "Edit Form Request" : "Send Form to Applicant"}
          </h2>
          <p>
            {data["id"]
              ? "Update the configuration for this form request."
              : "Select a form template and form type to request from the applicant, with optional custom remarks."}
          </p>
        </div>
        <div className="row">
          <div className="col-md-6">
            {this.renderSelect(
              "formId",
              "Select the form to send to the applicant",
              forms,
              "formTitle",
              "id",
              "fa-file-text-o"
            )}
          </div>
          <div className="col-md-6">
            {this.renderSelect(
              "formType",
              "Form Type",
              documentTypes,
              "name",
              "name",
              "fa-tag"
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="cannedMessage" className="form-control-label">
                Select Default Message
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-magic wf-input-icon" aria-hidden="true"></i>
                <select
                  name="cannedMessage"
                  id="cannedMessage"
                  className="form-control wf-input-withicon"
                  onChange={this.handleCannedMessage}
                  value={data["remarks"] || ""}
                >
                  <option value="">Select</option>
                  {cannedMessages.map((item) => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            {this.renderTextArea("remarks", "Remarks", "fa-pencil-square-o")}
          </div>
          <div className="col-md-12 text-center" style={{ marginTop: "24px", display: "flex", gap: "12px", justifyContent: "center" }}>
            <button className="btn-cancel-form" type="button" onClick={() => this.props.handleAddFormLibrary(false)} disabled={this.state.submitting}>
              <i className="fa fa-arrow-left" aria-hidden="true"></i> Back to Forms
            </button>
            <button className="btn-save-form" type="button" onClick={this.handleSubmit} disabled={this.state.submitting}>
              {this.state.submitting ? (
                <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> {data["id"] ? "Updating..." : "Sending..."}</>
              ) : (
                <><i className="fa fa-paper-plane" aria-hidden="true"></i> {data["id"] ? "Update Request" : "Send Request"}</>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AddFormLibrary;
